<template lang="pug">
.scroll(v-infinite-scroll="loadMore" :infinite-scroll-disabled="busy" infinite-scroll-distance="100")
  .list(:key="index" v-for="(item, index) in rfis")
    .container(@click="open(item, 'pendiente')" :class="{ pending: item.pendiente, answered: item.reply_date }")
      .row
        .left-col.center
          .p-img-cont
            img.round-imagen(:src="item.customer && item.customer.company_logo || require('@/assets/default-user-image.png')")
        .right-col
          .titlebox
            vm-row(vm-type="flex" vm-w="12")
              vm-col(vm-w="12")
                span.title {{ item.rfi_number }} - {{ item.project.project_name }}
                .date
                  span <b>Created on</b> {{ formatDate(item.requested_date) }} &nbsp;
                  span(v-if="item.reply_date") · <b>Replied on</b> {{ formatDate(item.reply_date) }}
                .attachments
                  vm-icon(icon="file-text-outline" v-if="item.attachments && item.attachments.length > 0")
                  stage-indicator.spaceTop(color="#3DCB6F" size="5px" v-if="item.reply_date")
            span {{ item.requested_information }}
          .rfi-view
            vm-icon(color="#777676" icon="eye" v-if="item.pendiente !== 1")
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Rfis')

export default {
  name: 'MiniaturaChat',
  components: {
    StageIndicator: () => import('@/components/aditionals/StageIndicator.vue')
  },
  data: () => ({
    currentPage: 1,
    loading: true,
    busy: false,
    defaultImage: '@/assets/default-user-image.png'
  }),
  async created () {
    await this.open(this.rfis[0], 'pendiente')
  },
  computed: {
    ...mapGetters([
      'pagination',
      'rfis'
    ])
  },
  methods: {
    ...mapActions([
      'loadRfisInfiniteList',
      'loadRfis'
    ]),
    formatDate (date) {
      return moment(date).format('ll')
    },
    open (rfi, action) {
      this.$emit('open', { record: rfi, action })
    },
    async loadMore () {
      this.loading = true
      if (this.currentPage <= this.pagination.totalPages) {
        this.currentPage++
        await this.getRfis(this.currentPage)
      }
      this.loading = false
    },
    async getRfis (page) {
      await this.loadRfisInfiniteList({ page })
    }
  }
}
</script>
<style lang="scss" scoped>
.scroll {
  height: calc(100vh - 110px);
  overflow-y: auto;
}
.container {
  user-select: none;
  cursor: pointer;
  height: 110px;
  border-radius: 5px;
  background: white;
  margin: 10px 10px 10px 0;
  padding: 14px 0px;
  overflow: hidden;
  display: flex;
  transition: 0.1s all ease-in-out;
  position: relative;
  border: 1px solid rgb(240, 240, 240);
  &:hover {
    -webkit-box-shadow: 5px 5px 7px 0px rgba(0,0,0,0.05);
    -moz-box-shadow: 5px 5px 7px 0px rgba(0,0,0,0.05);
    box-shadow: 5px 5px 7px 0px rgba(0,0,0,0.05);
  }
}
.p-img-cont {
  background: #cebebe;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  flex-shrink: 0;
  margin: 5px 10px 15px 10px;
  display: flex;
  justify-content: center;
  .round-imagen {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #e4e4e4;
    border-radius: 50%;
    box-sizing: content-box;
  }
}
.titlebox {
  padding: 6px 10px 5px 5px;
  font-size: 11px;
  color: #929191;
  width: 100%;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 14px;
    line-height: 14px;
    color: #777676;
    font-weight: bold;
  }
  .date {
    right: 30px;
    bottom: 3px;
    position: absolute;
    font-size: 10px;
    padding: 2px;
  }
  .attachments {
    display: flex;
    font-size: 1rem;
    right: 15px;
    bottom: 10px;
    position: absolute;
    padding: 2px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .spaceTop {
      margin: 10px 0 0 0;
    }
  }
}
.pending {
  border-left: rgba(var(--primary), 1) 1.5px solid !important;
}
.answered {
  border-left: #3DCB6F 1.5px solid;
}
.row {
  width: 100%;
  display: flex;
}
.left-col {
  display: flex;
  min-width: 30px;
  max-width: 60px;
}
.right-col {
  display: flex;
  width: 100%;
}
.center {
  display: flex;
  justify-content: center;
}
.rfi-view {
  margin: 0.2rem 2.2rem 0 0;
}
</style>
